import axios from "@/libs/api.request";

// 获取异常件列表
export const getAbnormalList = params => {
  return axios.request({
    url: "/warehouse/warehouse/exceptionList",
    method: "get",
    params
  });
};

// 获取操作人
export const getOperatorList = params => {
  return axios.request({
    url: "/common/exceptionUser",
    method: "get",
    params
  });
};
